import { useEffect, useRef } from 'react'

import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import { useRegistToSequentialList } from '@web/libs/sequential'
import Place_Review_Collector_Line from '@web/pages/mission/modal/lottie/Place_Review_Collector_Line.json'

import styles from './BoardAnimation.module.scss'

interface Props {
  order: number
  isEnd?: boolean
}

const LastFrame = 31

const BoardAnimation = ({ order, isEnd }: Props) => {
  const boardRef = useRef<LottieRefCurrentProps>(null)

  useRegistToSequentialList(
    {
      order,
      onExecute: () => boardRef.current?.play(),
      type: 'afterPrev',
      delaySeconds: 0,
      durationSeconds: 1,
      id: `board-${order}`,
    },
    { skip: isEnd },
  )

  useEffect(() => {
    if (!boardRef) return

    if (isEnd) {
      boardRef.current?.goToAndStop(LastFrame, true)
    } else {
      boardRef.current?.goToAndStop(0, true)
    }
  }, [isEnd])

  return (
    <div className={styles.lottie_area}>
      <Lottie
        className={styles.lottie_receipt_collector_bg}
        lottieRef={boardRef}
        loop={false}
        animationData={Place_Review_Collector_Line}
      />
    </div>
  )
}

export default BoardAnimation
